export default __webpack_public_path__ + "images/small_deepecho_icon_dark.27837836f2bcfa0a80b99902f5d7acce.png";